const HOME = '/'
const SIGNUP = '/register'
const LOGIN = '/login'
const ESTIMATION_SYSTEM = '/estimation-system'
const BUDGET_ESTIMATION = '/budget-estimation'
const VEHICLE_DETAILS = '/vehicles'
const USER = '/users'
const MY_LEAVES = '/my-leaves'
const LEAVE_MANEGEMENT = '/leave-management'
const FORGOT_PASSWORD = '/forgot-password'
const PRIVACY_POLICY = '/privacy-policy'
const ELMEC_PRIVACY_POLICY = '/elmec-privacy-policy'
const DELETE_PRIVACY_POLICY = '/delete-privacy-policy'
const DELETE_ACCOUNT_INFO = '/delete-account-info'
const RESET_PASSWORD = '/reset-password'
const PROFILE = '/profile'
const ANALYTICS = '/analytics'
const MAP = '/map'

export default {
    HOME,
    SIGNUP,
    LOGIN,
    ESTIMATION_SYSTEM,
    BUDGET_ESTIMATION,
    VEHICLE_DETAILS,
    USER,
    MY_LEAVES,
    LEAVE_MANEGEMENT,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    PROFILE,
    ANALYTICS,
    MAP,
    PRIVACY_POLICY,
    ELMEC_PRIVACY_POLICY,
    DELETE_PRIVACY_POLICY,
    DELETE_ACCOUNT_INFO,
}